import React from 'react'

import { useIntl } from 'react-intl'
import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { useRecoilValue, useResetRecoilState, useRecoilCallback } from 'recoil'
import { modalConcurrentAccess } from 'Pages/MessageEdit/recoil/state/modals'
import { editorState } from 'Pages/MessageEdit/recoil/state/editor'
import { exitCallback } from 'Pages/MessageEdit/recoil/callbacks/callbacks'
import modalMessageRedirect from 'Helpers/modalMessageRedirect'

export const ModalConcurrentAccess = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalConcurrentAccess)
  const resetModal = useResetRecoilState(modalConcurrentAccess)
  const exit = useRecoilCallback(exitCallback, [])
  const { concurrentAccessUsername } = useRecoilValue(editorState)
  const { redirect } = modalMessageRedirect()
  const handleClose = () => {
    resetModal()
    exit(false, messageType => {
      redirect(messageType)
    })
  }

  return (
    <Modal
      show={show}
      showClose={false}
      closeOnOverlayClick={false}
      data-mu-test='modal-message-concurrent-access'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalTitleForModOtherUsers'
        })}
      />
      <ModalBody>
        {intl.formatMessage(
          {
            id: 'Load.Bee.ModalDescrForModOtherUsers'
          },
          {
            strong: content => (
              <strong key='concurrentAccessUsername'>{content}</strong>
            ),
            NOME: concurrentAccessUsername
          }
        )}
      </ModalBody>
      <ModalFoot>
        <Button
          data-mu-test='button-message-concurrent-access'
          onClick={handleClose}
          kind='primary'
        >
          {intl.formatMessage({
            id: 'Load.Bee.ModalForContinueEditingTemplatePreviewCloseBtn'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
